import client from './client';

export const subscriptionsApi = {
  /**
   * Get available subscription plans
   */
  async getPlans() {
    const { data } = await client.get('/api/subscriptions/plans');
    return data;
  },

  /**
   * Get current user's subscription
   */
  async getCurrentSubscription() {
    const { data } = await client.get('/api/subscriptions/current');
    return data;
  },

  /**
   * Create checkout session for upgrading subscription
   */
  async createCheckoutSession(tier) {
    const { data } = await client.post('/api/subscriptions/checkout', { tier });
    return data;
  },

  /**
   * Create portal session for managing subscription
   */
  async createPortalSession() {
    const { data } = await client.post('/api/subscriptions/portal');
    return data;
  },

  /**
   * Get current usage stats against limits
   */
  async getUsage() {
    const { data } = await client.get('/api/subscriptions/usage');
    return data;
  },

  // Admin methods

  /**
   * Get all users with subscription info (admin only)
   */
  async getAdminUsers(params = {}) {
    const { data } = await client.get('/api/subscriptions/admin/users', { params });
    return data;
  },

  /**
   * Update a user's subscription tier (admin only)
   */
  async updateUserSubscription(userId, tier) {
    const { data } = await client.patch(`/api/subscriptions/admin/users/${userId}`, { tier });
    return data;
  },
};
